import { createApp } from 'vue';

import AgentListings from '../components/agent/agent-listings.vue';

// Powers the agent listing tabs on agent and broker detail pages.
const app = createApp({
	components: {
		AgentListings
	}
});

app.config.compilerOptions.whitespace = 'preserve';
app.mount('#agent-listings-container');
